module.exports = __webpack_public_path__ + "static/img/212_TO8_2155.505c3a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/212_TO8_2155.jpg
// module id = +kUs
// module chunks = 0